export class Validation {
  public name: string;
  public type: string;
  public min: number;
  public width: number;
  public inputMask: string;
  public message: MessagesValidation = new MessagesValidation();
  public nullable: boolean;
  public keyName: string;
}

export class MessagesValidation {
  nullable?: string = "";
  width?: string = "";
  min?: string = "";
  inputMask?: string = "";
}



// WEBPACK FOOTER //
// ./src/app/models/validation.model.ts